import React from 'react';
import { useCart } from '../context/CartContext';
import './Products.css';

function Books() {
  const { addToCart } = useCart();

  const booksProducts = [
    {
      id: 'book1',
      name: 'The Art of Programming',
      price: 29,
      originalPrice: 45,
      image: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Books',
      description: 'Comprehensive guide to modern programming'
    },
    {
      id: 'book2',
      name: 'Business Strategy Mastery',
      price: 24,
      originalPrice: 39,
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Books',
      description: 'Learn effective business strategies'
    },
    {
      id: 'book3',
      name: 'Cooking for Beginners',
      price: 19,
      originalPrice: 29,
      image: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Books',
      description: 'Easy recipes for home cooking'
    },
    {
      id: 'book4',
      name: 'Fitness & Nutrition Guide',
      price: 22,
      originalPrice: 35,
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Books',
      description: 'Complete guide to health and fitness'
    },
    {
      id: 'book5',
      name: 'Travel Photography',
      price: 27,
      originalPrice: 42,
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Books',
      description: 'Capture amazing travel moments'
    },
    {
      id: 'book6',
      name: 'Mindfulness Meditation',
      price: 18,
      originalPrice: 28,
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Books',
      description: 'Find inner peace and balance'
    },
    {
      id: 'book7',
      name: 'Science Fiction Collection',
      price: 31,
      originalPrice: 48,
      image: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Books',
      description: 'Best sci-fi stories of the year'
    },
    {
      id: 'book8',
      name: 'DIY Home Projects',
      price: 25,
      originalPrice: 38,
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Books',
      description: 'Creative projects for your home'
    }
  ];

  const handleAddToCart = (product) => {
    addToCart(product);
  };

  return (
    <div className="products-page">
      <div className="container">
        <div className="page-header">
          <h1>Books</h1>
          <p>Millions of titles available for every interest</p>
        </div>
        
        <div className="product-grid">
          {booksProducts.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <img src={product.image} alt={product.name} />
              </div>
              <div className="product-info">
                <h4>{product.name}</h4>
                <p className="product-description">{product.description}</p>
                <div className="price">
                                                          <span className="current-price">${parseFloat(product.price_usd || product.price || 0).toFixed(2)}</span>
                        <span className="original-price">${parseFloat(product.original_price_usd || product.originalPrice || 0).toFixed(2)}</span>
                  <span className="discount">
                    {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% off
                  </span>
                </div>
                <button 
                  className="add-to-cart"
                  onClick={() => handleAddToCart(product)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Books; 